import React, { useContext } from 'react';
import numeral from 'numeral';
import { Context as CountriesContext } from '../context/CountriesContext';
import { Context as StatContext } from '../context/StatContext';
import { Card, CardContent } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVirus,
  faSkullCrossbones,
  faHeartbeat
} from '@fortawesome/free-solid-svg-icons';
import { findCountry, statOptions } from '../utils';
import '../styles/Stats.css';

function StatsBox({ title, statType }) {
  const { state } = useContext(CountriesContext);
  const statState = useContext(StatContext);
  const country = findCountry(state.countries, state.selectedCountry);

  const borderColor =
    statType === statState.statType ? statStyles.border[statType] : null;
  return (
    <Card
      className={`stat ${borderColor}`}
      variant="outlined"
      onClick={() => statState.setStatType(statType)}>
      <CardContent>
        <div className="stat-info">
          <h2 style={{ color: statOptions[statType].color }}>
            {statStyles.icons[statType]}
          </h2>
          <div>
            <h3
              style={{
                letterSpacing: 1,
                fontWeight: 400,
                color: statOptions[statType].color
              }}>
              <em>{title}</em>
            </h3>
            <h2 style={{ fontWeight: 500, color: statOptions[statType].color }}>
              {numeral(country[statType]).format('0,0')}
            </h2>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

const statStyles = {
  border: {
    cases: 'stat--cases',
    recovered: 'stat--recovered',
    deaths: 'stat--deaths'
  },
  icons: {
    cases: <FontAwesomeIcon icon={faVirus} size="lg" />,
    recovered: <FontAwesomeIcon icon={faHeartbeat} size="lg" />,
    deaths: <FontAwesomeIcon icon={faSkullCrossbones} size="lg" />
  }
};

export default StatsBox;
